"use strict";
// This file gets environment variables with guards in case they are not set
Object.defineProperty(exports, "__esModule", { value: true });
exports.NODE_ENV = exports.REACT_APP_DISABLE_SEGMENT = exports.REACT_APP_SEGMENT_API_KEY = void 0;
var getProcessEnv = function (key) {
    try {
        return process.env[key];
    }
    catch (_a) {
        // continue
    }
    return undefined;
};
var getNodeEnv = function () {
    try {
        if (process.env.NODE_ENV) {
            if (['development', 'test', 'production'].includes(process.env.NODE_ENV)) {
                return process.env.NODE_ENV;
            }
            else {
                console.error('NODE_ENV is set to an unrecognized value.');
            }
        }
    }
    catch (_a) {
        // continue
    }
    // For non-appshell projects
    try {
        if (window.location.hostname.indexOf('.autodesk.') >= 0) {
            return 'production';
        }
    }
    catch (_b) {
        // continue
    }
    return undefined;
};
var REACT_APP_SEGMENT_API_KEY = getProcessEnv('REACT_APP_SEGMENT_API_KEY');
exports.REACT_APP_SEGMENT_API_KEY = REACT_APP_SEGMENT_API_KEY;
var REACT_APP_DISABLE_SEGMENT = getProcessEnv('REACT_APP_DISABLE_SEGMENT');
exports.REACT_APP_DISABLE_SEGMENT = REACT_APP_DISABLE_SEGMENT;
var NODE_ENV = getNodeEnv();
exports.NODE_ENV = NODE_ENV;
